import React from "react";
import $ from "jquery";
// import SocialSharingWidget from "../SocialSharingWidget";
import "./section-menu.scss";

type SectionMenuBarReducerType = [
    { anchorId: string },
    React.Dispatch<{ type: string; data: { anchorId: string } }>
];

export const SectionMenuBarReducer = (state: any, action: any) => {
    switch (action.type) {
        case "change":
            return { ...state, anchorId: action.data.anchorId };
        default:
            throw new Error();
    }
};

type Props = {
    permalink: string;
    data: Array<{
        name: string;
        href: string;
        anchorId: string;
    }>;
    reducer: SectionMenuBarReducerType
};

const SectionMenuBar: React.FC<Props> = (props: Props) => {
    const [state, dispatch] = props.reducer;
    const [isInit, setIsInit] = React.useState(true);

    // Initialize
    React.useLayoutEffect(() => {
        for (const d of props.data) {
            const $liAnchor = $(`#nav-item-${d.anchorId}`);
            $liAnchor.on("click", () => {
                dispatch({ type: "change", data: { anchorId: d.anchorId } });
            });
        }
    }, []);

    React.useLayoutEffect(() => {
        for (const d of props.data) {
            const $anchor = $(`#${d.anchorId}`);
            const $liAnchor = $(`#nav-item-${d.anchorId}`);
            if (d.anchorId === state.anchorId) {
                if (isInit) {
                    $anchor.fadeIn(0);
                    $liAnchor.addClass("active");
                } else {
                    $anchor.delay(299).fadeIn(300);
                    $liAnchor.addClass("active");
                }
            } else {
                if (isInit) {
                    $anchor.fadeOut(0);
                    $liAnchor.removeClass("active");
                } else {
                    $anchor.fadeOut(300);
                    $liAnchor.removeClass("active");
                }
            }
        }
        setIsInit(false);
    }, [props.data, state]);

    return (
        <section className="section-menu-bar">
            <nav className="section-menu-bar__nav">
                <div className="section-menu-bar__nav-container">
                    <ul className="container">
                        {props.data.map((x) => (
                            <li
                                id={`nav-item-${x.anchorId}`}
                                className="section-menu-bar__nav-container-item"
                                key={x.name}
                            >
                                <a className="section-menu-bar__nav-container-link">{x.name}</a>
                            </li>
                        ))}
                        <li className="nav-item section-menu-bar__social">
                            {/* <SocialSharingWidget
                                title=""
                                text=""
                                permalink={props.permalink}
                            /> */}
                        </li>
                    </ul>
                </div>
            </nav>
        </section>
    );
};

export default SectionMenuBar;
